import styled from 'styled-components';

import { NewStyleColor, macTopBarHeight } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';
import UserAgentUtils from '../../utils/userAgent';

const ACTION_BAR_HEIGHT = 50;
export const HEADER_HEIGHT = UserAgentUtils.isMacApp()
	? ACTION_BAR_HEIGHT + parseInt(macTopBarHeight, 10)
	: ACTION_BAR_HEIGHT;
export const PAGE_PADDING = 27;

interface LoaderProps {
	isProcessing?: boolean;
}

interface PageElementActionButtonProps {
	isActive: boolean;
	pageScale: number;
	spreadZoom: number;
}

interface EditorScrollStylesConfig {
	width: number;
}

const getEditorScrollStyles = (config?: EditorScrollStylesConfig) => !UserAgentUtils.isMobileApp
	? `
		&::-webkit-scrollbar {
			width: ${config && config.width || 16}px;
		}

		&::-webkit-scrollbar-track {
			background-color: ${hexToRgba(NewStyleColor.Black, 20)};
		}

		&::-webkit-scrollbar-thumb {
			background-color: ${hexToRgba(NewStyleColor.White, 20)};
		}

		&::-webkit-scrollbar-corner {
			background-color: ${hexToRgba(NewStyleColor.Black, 20)};
		}`
	: '';

const EditorContainer = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

const EditorWrapper = styled('div')`
	position: absolute;
	top: ${HEADER_HEIGHT}px;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	background-color: ${NewStyleColor.Grey1000};
`;

const ContentWrapper = styled('div')`
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

const ContentInner = styled('div')`
	flex: 1 1 auto;
	display: flex;
	overflow-x: hidden;
	overflow-y: auto;
`;

const SpreadWrapper = styled('div')`
	position: relative;
	flex: 1 1 auto;
	display: flex;
	overflow: auto;

	${getEditorScrollStyles()}
`;

const Loader = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${hexToRgba(NewStyleColor.Black, 75)};
	font-weight: bold;
	font-size: 21px;
	color: ${NewStyleColor.White};

	${({ isProcessing }: LoaderProps) => isProcessing && 'z-index: 11;'}
`;

const PageElementActionButton = styled('button').attrs({
	type: 'button',
})`
	position:  ${({ isAccessibleVersion }) => isAccessibleVersion ? 'relative' : 'absolute'};
	top: ${({ isAccessibleVersion }) => isAccessibleVersion ? '25px' : '0'};
	left: 0;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	padding: 0;
	border: 2px solid currentColor;
	border-radius: 50%;
	outline: 0;
	background-color: ${NewStyleColor.Black};
	color: ${NewStyleColor.White};
	box-shadow: 0 0 5px 0 ${hexToRgba(NewStyleColor.Black, 12)}, 0 2px 14px 0 ${hexToRgba(NewStyleColor.Black, 32)};
	pointer-events: auto;
	cursor: pointer;
	transform-origin: 0 0;
	margin-bottom: ${({ isVisible }) => !isVisible ? '25px' : '0'};
	z-index: 100;

	${({ pageScale, spreadZoom }: PageElementActionButtonProps) => spreadZoom >= 1 && `transform: scale(${1 / pageScale});`}
	${({ isActive }: PageElementActionButtonProps) => isActive && 'z-index: 1;'}

	svg {
		width: 12px;
		height: 12px;
		fill: currentColor;
		margin: 0;
	}
`;

export {
	EditorContainer,
	EditorWrapper,
	ContentWrapper,
	ContentInner,
	SpreadWrapper,
	Loader,
	PageElementActionButton,
	getEditorScrollStyles,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/styles.ts